<div #TemporaryViewContainerRef></div>

<div class="survey-container contentcontainer codecontainer">
    <div id="surveyElement"></div>
</div><!-- Don't need with SurveyWindowNG, used with SurveyNG -->